import { apiFetch } from "../../http";
const withQuery = (path, query) => {
    const entries = Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== "");
    if (!entries.length)
        return path;
    const qs = entries
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join("&");
    return `${path}?${qs}`;
};
export async function getTravelItemsMap(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/get_travel_items_map/${travelPlanId}/${params.summary ? '?view=summary' : '?view=editor'}`, {
        baseUrl,
        token,
        method: "GET",
        cache: "no-store"
    });
}
export async function getTravelMapTracks(params) {
    const { baseUrl, travelPlanId, userId, token } = params;
    const path = withQuery(`/travel/api/get_travel_map/${travelPlanId}/`, { user_id: userId });
    return apiFetch(path, {
        baseUrl,
        token,
        method: "GET",
        cache: "no-store"
    });
}
export async function getTravelMapPoints(params) {
    const { baseUrl, travelPlanId, userId, token } = params;
    const path = withQuery(`/travel/api/get_travel_point/${travelPlanId}/`, { user_id: userId, view: params.summary ? 'summary' : 'editor' });
    return apiFetch(path, {
        baseUrl,
        token,
        method: "GET",
        cache: "no-store"
    });
}
export async function deleteAllTravelPoints(params) {
    const { baseUrl, travelPlanId, token, csrfToken } = params;
    return apiFetch(`/travel/api/delete_all_travel_points/${travelPlanId}/`, {
        baseUrl, token, method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
    });
}
export async function deleteTravelPoint(params) {
    const { baseUrl, travelPlanId, pointId, token, csrfToken } = params;
    return apiFetch(`/travel/api/delete_user_point/${travelPlanId}/${pointId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
export async function createTravelPoints(params) {
    const { baseUrl, travelPlanId, formData, token, csrfToken } = params;
    return apiFetch(`/travel/api/point_travel_created/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData
    });
}
export async function updateTravelPoint(params) {
    const { baseUrl, travelPlanId, pointId, patch, formData, token, csrfToken } = params;
    const hasFormData = formData instanceof FormData;
    return apiFetch(`/travel/api/point_travel_updated/${travelPlanId}/${pointId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: hasFormData
            ? (csrfToken ? { "X-CSRFToken": csrfToken } : undefined)
            : {
                "Content-Type": "application/json",
                ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
            },
        body: hasFormData ? formData : JSON.stringify(patch !== null && patch !== void 0 ? patch : {})
    });
}
export async function createTravelGpxTracks(params) {
    const { baseUrl, travelPlanId, formData, token, csrfToken } = params;
    return apiFetch(`/travel/api/gpx_travel_created/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData
    });
}
export async function getTravelGpxTaskStatus(params) {
    const { baseUrl, travelPlanId, taskId, token } = params;
    return apiFetch(`/travel/api/gpx_task_status/${travelPlanId}/${taskId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function getTravelTaskStatus(params) {
    const { baseUrl, travelPlanId, taskId, token } = params;
    return apiFetch(`/travel/api/task_status/${travelPlanId}/${taskId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function setTravelItemSelected(params) {
    const { baseUrl, travelPlanId, itemTravelId, selected, token, csrfToken } = params;
    return apiFetch(`/travel/api/item_travel_select/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({
            item_travel_id: itemTravelId,
            selected
        })
    });
}
export async function setTravelPointSelected(params) {
    const { baseUrl, travelPlanId, pointTravelId, selected, token, csrfToken } = params;
    return apiFetch(`/travel/api/point_travel_select/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({
            point_travel_id: pointTravelId,
            selected
        })
    });
}
